import { Drawer, Group, ThemeIcon, Title } from '@mantine/core'
import { useGlobalState } from '@opsopti/shared'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLocation } from 'wouter'

import { theme } from '@/configs/theme'

export const FormDrawers = observer(function FormDrawers() {
  const [pathname] = useLocation()
  const { uiStore } = useGlobalState()

  useEffect(() => {
    uiStore.closeFormDrawer({ closeAll: true })
  }, [pathname])

  return Array.from({ length: Math.max(uiStore.formDrawers.length, 3) }, (_v, i) => uiStore.formDrawers[i] ?? {}).map(
    ({ Component, ComponentProps, DrawerProps, TitleProps }, index) => {
      const Icon = TitleProps?.Icon

      return (
        <Drawer
          key={index}
          size={theme.rem(520)}
          position="right"
          offset="1dvw"
          radius="md"
          withCloseButton
          closeOnClickOutside
          closeOnEscape
          keepMounted
          opened={!!Component}
          onClose={uiStore.closeFormDrawer}
          transitionProps={{ duration: 200 }}
          styles={{
            content: {
              marginRight: `calc(1dvw + ${index * 50}px)`,
            },
          }}
          title={
            TitleProps?.title ? (
              <Group wrap="nowrap" align="flex-start">
                <ThemeIcon variant="filled" size={theme.rem(36)}>
                  {Icon && <Icon />}
                </ThemeIcon>
                <Title order={6} fw={500}>
                  {TitleProps.title}
                </Title>
              </Group>
            ) : undefined
          }
          {...DrawerProps}>
          {!!Component && <Component {...ComponentProps} />}
        </Drawer>
      )
    },
  )
})
